module.exports = __webpack_public_path__ + "img/BG@2x.b4baeb31.png";